import React from 'react'

function AccessDenied() {
   return <div className="content">You dont have permission to view this page.</div>
}

export default AccessDenied
